
/**
 * Utility functions for handling files
 */

import { saveAs } from 'file-saver';

/**
 * Save data to a file and trigger download
 * @param data The data to save
 * @param filename The name of the file
 */
export const saveToFile = (data: string, filename: string): void => {
  const blob = new Blob([data], { type: 'application/json' });
  saveAs(blob, filename);
};

/**
 * Read data from a file
 * @param file The file to read
 * @returns Promise resolving to the file contents as a string
 */
export const readFromFile = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      if (event.target?.result) {
        resolve(event.target.result as string);
      } else {
        reject(new Error('Failed to read file'));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Error reading file'));
    };
    
    reader.readAsText(file);
  });
};

/**
 * Convert a file to a data URL
 * @param file The file to convert
 * @returns Promise resolving to the data URL
 */
export const fileToDataUrl = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      if (event.target?.result) {
        resolve(event.target.result as string);
      } else {
        reject(new Error('Failed to convert file to data URL'));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Error converting file to data URL'));
    };
    
    reader.readAsDataURL(file);
  });
};
